import {
    GET_FEATURED_WEATHER_CAMS,
    GET_CATEGORIES_WEATHER_CAMS
} from '../actions/featuredCategoriesWeatherCamsActions';

const initialState = {
    featuredWeatherCams: [],
    categoriesWeatherCams: [],
    featuredWeatherCamsIsLoading: false,
    categoriesWeatherCamsIsLoading: false,
    featuredWeatherCamsLastError: undefined,
    categoriesWeatherCamsLastError: undefined
};

export function featuredCategoriesWeatherCams(state = initialState, action) {
    switch (action.type) {
        case GET_FEATURED_WEATHER_CAMS.pending:
        {
            return {
                ...state,
                featuredWeatherCamsIsLoading: true
            };
        }
        case GET_FEATURED_WEATHER_CAMS.fulfilled:
        {
            return {
                ...state,
                featuredWeatherCamslastError: undefined,
                featuredWeatherCamsIsLoading: false,
                featuredWeatherCams: action.payload
            };
        }
        case GET_FEATURED_WEATHER_CAMS.rejected:
        {
            return {
                ...state,
                featuredWeatherCamslastError: action.payload,
                featuredWeatherCamsIsLoading: false
            };
        }
        case GET_CATEGORIES_WEATHER_CAMS.pending:
        {
            return {
                ...state,
                categoriesWeatherCamsIsLoading: true
            };
        }
        case GET_CATEGORIES_WEATHER_CAMS.fulfilled:
        {
            return {
                ...state,
                categoriesWeatherCamsLastError: undefined,
                categoriesWeatherCamsIsLoading: false,
                categoriesWeatherCams: action.payload
            };
        }
        case GET_CATEGORIES_WEATHER_CAMS.rejected:
        {
            return {
                ...state,
                categoriesWeatherCamsLastError: action.payload,
                categoriesWeatherCamsIsLoading: false
            };
        }
    }

    return state;
}
